import React, { useState } from "react";

import "styles/components/promo.scss";
import useConfig from "hooks/useConfig";
import { useAuth } from "hooks/useAuth";
import { sendPromoValidationRequest } from "services/PromoService";
import { BRAND_CODES } from "../consts";

const PromoForm = ({ onChange, promoCode }) => {
  const [validationError, setValidationError] = useState(false);
  const [discountCode, setDiscountCode] = useState("");
  const { apiUrl, apiAccessToken, brand, env } = useConfig();
  const { customer } = useAuth({ apiAccessToken, apiUrl, brand, env });

  const shouldValidatePromoCode = [BRAND_CODES.SE, BRAND_CODES.TP].includes(brand);

  const validatePromoCode = async () => {
    const { data } = await sendPromoValidationRequest({
      promoCode: discountCode,
      apiUrl,
      apiAccessToken,
      brand,
      env,
      customer
    });
    const { result, errors } = data;
    if (result) {
      return onChange("promoCode")(result);
    }
    if (errors) {
      return setValidationError(errors[0].message);
    }
  };

  const validateGTRPromoCode = async () => {
    onChange("promoCode")({ promoCode: discountCode });
  };

  const removePromoCode = () => {
    setDiscountCode("");
    onChange("promoCode")(null);
  };

  const onCTAClick = () => {
    if (promoCode) {
      return removePromoCode();
    }

    if (discountCode.length > 2) {
      return shouldValidatePromoCode ? validatePromoCode() : validateGTRPromoCode();
    }
  };

  const onDiscountInputChange = ({ target }) => {
    setDiscountCode(target.value);
    setValidationError(null);
  };

  const renderCodeInput = () => {
    const discountInputValidationProps = validationError
      ? { "aria-describedby": "promo-validation-error", "aria-invalid": true }
      : {};

    if (promoCode && promoCode.promoCode) {
      return (
        <div className="otrl-jp__promo-form__applied-code">{`Code ${promoCode.promoCode} applied`}</div>
      );
    }

    return (
      <input
        className={`input-field ${validationError && "validation-error"}`}
        value={discountCode}
        onChange={onDiscountInputChange}
        placeholder={`Discount code...`}
        maxLength={20}
        {...discountInputValidationProps}
      />
    );
  };

  const renderValidationResult = () => {
    if (validationError) {
      return (
        <span
          className="alert-warning otrl-jp__passengers__railcards__error"
          id="promo-validation-error"
          role="alert"
        >
          {validationError}
        </span>
      );
    }
    const limitationsInfo = promoCode && promoCode.limitationsCopy && promoCode.limitationsCopy.replace(/\n/g, "<br />");

    if (!limitationsInfo) {
      return null;
    }

    return (
      <div
        className="otrl-jp__promo-form__terms"
        dangerouslySetInnerHTML={{ __html: limitationsInfo }}
      />
    );
  };

  const CTAText = promoCode ? "Remove" : "Apply";
  const CTAAria = `${CTAText} discount code`;
  return (
    <div className="otrl-jp__promo-form">
      <div className="otrl-jp__promo-form__input-wrapper">
        {renderCodeInput()}

        <button
          className="otrl-jp__button otrl-jp__promo-form__button"
          aria-label={CTAAria}
          onClick={onCTAClick}
          type="button"
        >
          {CTAText}
        </button>
      </div>

      {renderValidationResult()}
    </div>
  );
};

export default PromoForm;
